module.exports = __webpack_public_path__ + "img/flutter.b62c7ddf.svg";